export enum AppType {
  VISIOPHARM = 'VISIOPHARM',
  QUPATH = 'QUPATH',
  CELL_COUNTING = 'CELL_COUNTING'
}
